export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_45',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_bundle_45_usd',
		},
		primer: 'prd_If8Q3EpLqWkH',
	},
	otp: {
		priceMap: {
			USD: 45,
		},
	},
}
